import { useAppSelector } from 'app/hooks';
import useIsDuctedOnlyPathway from 'hooks/use-is-ducted-only-pathway';
import useStructureTonnage, {
  useTonnageSkipEligible
} from 'hooks/use-structure-tonnage';
import { selectDuctedDesignRequired } from 'utils/ducted-design';
import { isUnsureTonnage } from 'utils/tonnage-logic';

// Whether the Layout & Sizing skip is on offer at all (drives the header's
// 'Optional' badges): the ducted tonnage gate.
export function useSizeSkipEligible(): boolean {
  const ductedDesignRequired = useAppSelector(selectDuctedDesignRequired);
  const tonnageSkipEligible = useTonnageSkipEligible();
  return tonnageSkipEligible && !ductedDesignRequired;
}

// Whether the Equipment Preferences footer offers "See Matching Systems"
// (with "Get a Detailed Sizing Estimate" beside it) instead of the plain
// "Next Section". On the ducted-only pathway that is every size answer but
// Unsure: Unsure is the one answer that asks for Layout & Sizing, so it
// alone keeps Next Section as the only way forward. No size answered yet
// counts as not-Unsure — the buttons show, and the page progress gate keeps
// them disabled until the size is answered. Stays on the default footer
// until the selections hydrate, so a saved Unsure never flashes the skip.
export function useSizeSkipArmed(): boolean {
  const ductedOnly = useIsDuctedOnlyPathway();
  const ductedDesignRequired = useAppSelector(selectDuctedDesignRequired);
  const tonnage = useStructureTonnage();
  return (
    ductedOnly &&
    !ductedDesignRequired &&
    tonnage.loaded &&
    tonnage.system !== null &&
    !isUnsureTonnage(tonnage.record)
  );
}
